import { render, staticRenderFns } from "./StatisticsBarCardTaxes.vue?vue&type=template&id=516301f6&"
import script from "./StatisticsBarCardTaxes.vue?vue&type=script&lang=js&"
export * from "./StatisticsBarCardTaxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports